import React, { useCallback, useEffect, useState } from "react";
import { Link,useHistory } from "react-router-dom";
import { Row, Col, Card, Table, Spin, Button, Input, Divider, notification, Modal, Select, Avatar } from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import { FileExcelOutlined, EyeOutlined, UserOutlined, SaveOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import * as XLSX from 'xlsx';
import 'antd/dist/antd.css';

const { Option } = Select;

const createStyledTitle = (text) => (
  <span style={{ fontSize: '13px', color: '#7a0000', fontWeight: 700 }}>{text}</span>
);

function YealyReport() {

  const history = useHistory();

  const [userList, setUserList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false); // State to manage the loade
  const [filters, setFilters] = useState({
    name: '',
    email: '',
    phone: '',
    father_name: '',
    caste: '',
    gotra: '',
    village: '',
    district: '',
    announced_amount: '',
    max_announced_amount: '',
    start_joining_date: '',
    end_joining_date: '',
  });
  const [isResponseModalVisible, setIsResponseModalVisible] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [responsePagination, setResponsePagination] = useState({});
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    getUserList();
  }, []);

  const columns = [
    {
      title: createStyledTitle("S.No"),
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 55,
      render: (text) => <span style={{ fontWeight: 600, fontSize: 12, color: '#7a0000' }}>{text}</span>,
    },
    {
      title: createStyledTitle("Name"),
      dataIndex: "name",
      key: "name",
      fixed: 'left',
      width: 220,
    },
    {
      title: createStyledTitle("Phone"),
      dataIndex: "phone_no",
      key: "phone_no",
      width: 130,
    },
    {
      title: createStyledTitle("Village"),
      dataIndex: "per_village",
      key: "per_village",
      width: 120,
    },
    {
      title: createStyledTitle("District"),
      dataIndex: "per_district",
      key: "per_district",
      width: 120,
    },
    {
      title: createStyledTitle("Monthly Share"),
      key: "announced_amount",
      dataIndex: "announced_amount",
      width: 120,
    },
    {
      title: createStyledTitle("Total Amount"),
      key: "total_amount",
      dataIndex: "total_amount",
      width: 130,
    },
    {
      title: createStyledTitle("Up to Month"),
      key: "up_to_month",
      dataIndex: "up_to_month",
      width: 120,
    },
    {
      title: createStyledTitle("Action"),
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 70,
    },
  ];

  const [editingKey, setEditingKey] = useState('');
  const [editingResponse, setEditingResponse] = useState('');
  const [editingResponseForBackup, setEditingResponseForBackup] = useState('');

  const isEditing = (key) => key === editingKey;

  const editResponse = (key, text) => {
    setEditingKey(key);
    setEditingResponse(text);
    setEditingResponseForBackup(text);
  };

  const cancelEdit = () => {
    setEditingKey('');
    setEditingResponse('');
    setEditingResponseForBackup('');
  };

  const saveResponse = async (key) => {
    try {
      if (editingResponse === editingResponseForBackup) {
        setEditingKey('');
        setEditingResponse('');
        setEditingResponseForBackup('');
      } else {
        const response = await axios.put(`${baseUrl}/users/updateResponse`, {
          user_id: key,
          latest_payment_response: editingResponse
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          }
        });
        if (response.data.status) {
          notification.success({
            message: 'Success',
            description: 'Response updated successfully',
            placement: 'topRight'
          });
          getUserList(currentPage, limit, sortField, sortOrder, search, filters);
        } else {
          notification.error({
            message: 'Error',
            description: response.data.message,
            placement: 'topRight'
          });
        }
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }

    setEditingKey('');
    setEditingResponse('');
    setEditingResponseForBackup('');
  };

  const handleKeyDown = (e, userId) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default behavior (e.g., new line in textarea)
      saveResponse(userId);
    }
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  async function getUserList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/reports/yearlyList?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setUserList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    getUserList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleSearch = value => {
    setSearch(value);
    getUserList(currentPage, limit, sortField, sortOrder, value, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    getUserList(1, value, sortField, sortOrder, search, filters);
  };

  const debouncedGetUserList = useCallback(debounce((page, limit, sortField, sortOrder, search, filters) => {
    getUserList(page, limit, sortField, sortOrder, search, filters);
  }, 300), []);

  useEffect(() => {
    const filterKeys = Object.keys(filters);

    // Check if any filter other than 'createdBy' has a length of 3 or more
    const anyFilterHasMinLength = filterKeys.some(
      key => key !== 'createdBy' && filters[key].length >= 1
    );

    // Check if all filters are either empty or specifically 'createdBy'
    const allFiltersEmptyOrCreatedBy = filterKeys.every(
      key => key === 'createdBy' || !filters[key]
    );

    if (anyFilterHasMinLength || allFiltersEmptyOrCreatedBy) {
      debouncedGetUserList(currentPage, limit, sortField, sortOrder, search, filters);
    }
  }, [filters, currentPage, limit, sortField, sortOrder, search]);

  const handleFilterChange = (field, value) => {
    setFilters({
      ...filters,
      [field]: value
    });
  };

  const exportToExcel = async () => {
    setLoading(true);
    const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
    const searchParam = search ? `&search=${search}` : '';
    const filterParams = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&');
    const response = await axios.get(`${baseUrl}/reports/yearlyList?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      }
    });
    if (response.data.status) {
      setLoading(false);

      const minYear = response.data.minYear;  // Ideally, get this from the backend or use a predefined year
      const maxYear = response.data.maxYear;  // Ideally, get this from the backend or use a predefined year
  
      
      const formattedData = response.data.result.map((user, index) => {
        // Basic columns for each user
        const rowData = {
          "Sr.No": index + 1,
          "Phone no": user.phone_no,
          "Name": user.name,
          "Father Name": user.father_name,
          "Village": user.per_village,
          "District": user.per_district,
          "Monthly Share": user.announced_amount,
          "Total Received Amount": user.total_amount
        };
    
        // Loop to add dynamic yearly columns based on the minYear and maxYear
        for (let year = minYear; year < maxYear; year++) {
          const yearKey = `${year}-${year + 1}`;
          // Check if the data for that year exists in the response
          rowData[yearKey] = user[`${year}-${year + 1}`] || 0; // Add the yearly amount or 0 if missing
        }
    
        return rowData;
      })

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "yearly Report");
      XLSX.writeFile(workbook, "yearly-Report.xlsx");
    } else {
      setLoading(false);
      notification.info({
        message: 'Info',
        description: response.data.message,
        placement: 'topRight'
      });
    }
  };

  // For show image on model large
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const showModal = (image) => {
    setCurrentImage(image || userDummy);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const fetchUserResponses = async (userId, page = 1, limit = 10) => {
    try {
      const response = await axios.get(`${baseUrl}/users/get_last_response/${userId}?page=${page}&limit=${limit}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setResponseData(response.data.result);
        setResponsePagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  const showResponseModal = (userId) => {
    setCurrentUserId(userId);
    fetchUserResponses(userId);
    setIsResponseModalVisible(true);
  };

  const handleResponseModalCancel = () => {
    setIsResponseModalVisible(false);
  };

  const handleView = (id) => {
    history.push({
      pathname: `/users/view/${id}`
      
    });
  };


  return (
<>
    {
      loading && (
        <div className="full-page-loader">
          <Spin size="large" />
        </div>
      )
    }
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Yearly Report</span>}
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                pagination={false}
                scroll={{ x: 'max-content' }}
                bordered
                title={() => (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Row gutter={[16, 16]}>
                      <Col span={4}>
                        <Input placeholder="Phone" value={filters.phone} onChange={e => handleFilterChange('phone', e.target.value)} />
                      </Col>
                      <Col span={4}>
                        <Input placeholder="Name" value={filters.name} onChange={e => handleFilterChange('name', e.target.value)} />
                      </Col>
                      <Col span={4}>
                        <Input placeholder="Father Name" value={filters.father_name} onChange={e => handleFilterChange('father_name', e.target.value)} />
                      </Col> 
                      <Col span={3}>
                        <Input placeholder="Village" value={filters.village} onChange={e => handleFilterChange('village', e.target.value)} />
                      </Col>
                      <Col span={3}>
                        <Input placeholder="District" value={filters.district} onChange={e => handleFilterChange('district', e.target.value)} />
                      </Col>
                      <Col span={8}>
                        <div className="amount-range-input">
                          <Input
                            placeholder="Min Total Amount"
                            value={filters.announced_amount}
                            onChange={e => handleFilterChange('announced_amount', e.target.value)}
                            style={{ marginBottom: '8px' }}
                          />
                          <span className="range-separator">-</span>
                          <Input
                            placeholder="Max Total Amount"
                            value={filters.max_announced_amount}
                            onChange={e => handleFilterChange('max_announced_amount', e.target.value)}
                          />
                        </div>
                      </Col>
                  

                     

                      <Divider />
                      <Row gutter={16} style={{ marginBottom: '16px', textAlign: 'right' }}>
                        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
                          {/* <Button type="primary" icon={<SearchOutlined />} >
                            Search Report
                          </Button> */}
                          {hasPermission('/reports/yearly-report', 'downloadPermission') && (
                          <Button type="default" icon={<FileExcelOutlined />} onClick={exportToExcel}>
                            Excel Download
                          </Button>
                          )}
                        </Col>
                      </Row>
                      <Divider />
                      <Col xs={24}>
                        <span style={{ marginRight: 10, fontSize: 13 }}>Records per page:</span>
                        <Select defaultValue={20} onChange={handleLimitChange}>
                          <Option value={20}>20</Option>
                          <Option value={40}>40</Option>
                          <Option value={60}>60</Option>
                          <Option value={80}>80</Option>
                          <Option value={100}>100</Option>
                        </Select>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={userList.map((user, index) => ({
                  key: (limit * (currentPage - 1)) + index + 1,
                  name: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Avatar
                        shape="square"
                        size={34}
                        src={user.profile_img || userDummy}
                        icon={!user.profile_img && <UserOutlined />}
                        onClick={() => showModal(user.profile_img || userDummy)}
                        style={{ cursor: 'pointer', borderRadius: 4, flexShrink: 0 }}
                      />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13, color: '#7a0000' }}>
                          <Link to={`/users/view/${user.user_id}`} style={{ color: '#1890ff' }}>{user.name}</Link>
                        </div>
                        {(user.relation_en || user.father_name) && (
                          <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                            {(user.relation_en || user.relation_hn) && (
                              <span style={{ color: '#aaa' }}>
                                {user.relation_en && user.relation_hn ? `${user.relation_en} / ${user.relation_hn}` : user.relation_en || user.relation_hn}{' '}
                              </span>
                            )}
                            {user.father_name}
                          </div>
                        )}
                      </div>
                    </div>
                  ),
                  phone_no: (
                    <div>
                      <div style={{ fontWeight: 500, fontSize: 13 }}>{user.phone_no || '—'}</div>
                      {user.alternate_phone_no && <div style={{ fontSize: 11, color: '#888' }}>{user.alternate_phone_no}</div>}
                    </div>
                  ),
                  per_village: <span style={{ fontSize: 12 }}>{user.per_village || '—'}</span>,
                  per_district: <span style={{ fontSize: 12 }}>{user.per_district || '—'}</span>,
                  announced_amount: <span style={{ fontWeight: 600, color: '#faad14' }}>{user.announced_amount ? 'Rs.' + user.announced_amount : '—'}</span>,
                  total_amount: <span style={{ fontWeight: 600, color: '#52c41a' }}>{user.total_amount ? 'Rs.' + user.total_amount : '—'}</span>,
                  up_to_month: <span style={{ fontSize: 12 }}>{user.up_to_month ? moment(user.up_to_month).format('MMM YYYY') : '—'}</span>,
                  action: (
                    <div>
                      {hasPermission('/users', 'readPermission') && (
                        <Link onClick={() => handleView(user.user_id)} className="update-btn">
                          <EyeOutlined />
                        </Link>
                      )}
                    </div>
                  )
                }))}
                pagination={{
                  ...pagination,
                  showTotal: total => `Total ${total} records`,
                  style: { marginRight: 20 }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%' }}
        />
      </Modal>

      <Modal
        open={isResponseModalVisible}
        footer={null}
        onCancel={handleResponseModalCancel}
        width={800}
      >
        <Table
          columns={[
            {
              title: 'Response',
              dataIndex: 'response',
              key: 'response',
              width: 500,
              render: (text) => <div>{text}</div>
            },
            {
              title: 'Date',
              dataIndex: 'createdAt',
              key: 'createdAt',
              render: (text) => <div>{moment(text).format('DD-MM-YYYY')}</div>
            }
          ]}
          dataSource={responseData}
          pagination={{
            ...responsePagination,
            onChange: (page, pageSize) => fetchUserResponses(currentUserId, page, pageSize),
          }}
          rowKey="id"
        />
      </Modal>

    </div>
    </>
  );
}

export default YealyReport;
